import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatDialogContent, MatDialogActions, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-log-viewer-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatButtonModule
  ],
  template: `
    <h2 mat-dialog-title>Archive Logs</h2>
    <mat-dialog-content style="max-height:60vh;overflow:auto;">
      <div *ngIf="data?.error" class="error">{{data.error}}</div>
      <div *ngIf="!data?.error">
        <div *ngIf="data?.data?.archiveDetails?.archiveId">
          <b>Archive ID:</b> {{data.data.archiveDetails.archiveId}}
        </div>
        <div *ngIf="data?.data?.actualLogs?.length">
          <b>Actual Logs:</b>
          <ul style="max-height:180px;overflow:auto;background:#f7f7f7;padding:8px 12px;border-radius:6px;">
            <li *ngFor="let log of data.data.actualLogs">{{log}}</li>
          </ul>
        </div>
        <div *ngIf="data?.data?.logMessages?.length">
          <b>Log Messages:</b>
          <ul style="max-height:180px;overflow:auto;background:#f7f7f7;padding:8px 12px;border-radius:6px;">
            <li *ngFor="let log of data.data.logMessages">{{log}}</li>
          </ul>
        </div>
        <div *ngIf="data?.data && !data?.data?.actualLogs && !data?.data?.logMessages">
          <pre style="background:#f7f7f7;padding:12px;border-radius:6px;">{{ data.data | json }}</pre>
        </div>
        <details style="margin-top:16px;">
          <summary style="cursor:pointer;">Show Full JSON</summary>
          <pre style="font-size:13px;white-space:pre-wrap;word-break:break-all;background:#f7f7f7;padding:12px;border-radius:6px;">{{ data | json }}</pre>
        </details>
        <button mat-stroked-button color="primary" style="margin-top:12px;" (click)="copyJson()">Copy JSON</button>
        <span *ngIf="copied" style="color:green;margin-left:8px;">Copied!</span>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `
})
export class LogViewerDialogComponent {
  copied = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LogViewerDialogComponent>
  ) {}

  copyJson() {
    const text = JSON.stringify(this.data, null, 2);
    navigator.clipboard.writeText(text);
    this.copied = true;
    setTimeout(() => (this.copied = false), 1500);
  }
} 